import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

// let headers = ''

// function headersSet() {
//   const headersQ = window.localStorage.getItem('Headers')
//   headers = JSON.parse(headersQ)
// }

export const addBooker  = createAsyncThunk('appBooker/addBooker', async (Client) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Booking/AddBooker', Client, {mode:'cors'})
      
    if (response.data.code === undefined || response.data.code === 200) {
      return {
        data: response
      }
    } else {
      return {
        data: response.data.code
      }
    }
  })

  export const editBooker  = createAsyncThunk('appBooker/editBooker', async (Client) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Booking/UpdateBooker', Client, {mode:'cors'})
   
    return response.data
  })

  export const getBookerdetail  = createAsyncThunk('appBooker/getBookerdetail', async (Client) => {
     
    const response = await axios.post(' https://api.zasway.com:8443/Booking/GetTableSummaryBooker', Client, {mode:'cors'})
     
    return response.data
  })
  

  export const CloseModelBooker = createAsyncThunk('/appPassenger/CloseModelBooker', (IsClosedBooker) => {
    
    return { data: IsClosedBooker }
  })
  
  export const ResetCloseModelBooker = createAsyncThunk('/commonLocation/ResetCloseModelBooker', () => {
    return {
      data: false
    }
  })
 
  export const setRecentlyAddedBookerID = createAsyncThunk('/appPassenger/setRecentlyAddedBookerID', (RecentBookerID) => {

    return {
      data: RecentBookerID
    }
  })
  export const setBookerNull = createAsyncThunk('/appPassenger/setBookerNull', () => {
    return true
  })
export const appBookerSlice = createSlice({
  name: 'appBooker',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    IsClosedBooker: false,
    selectedUser: null,    
    recentBookerID: 0,
    PassengerWeekDaysData: [],
    PassengerBookingTrends: [],
    AllBookingTrends: [],
    Loader: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
    .addCase(setBookerNull.pending, (state) => {
      state.Loader = true
    })
    .addCase(setBookerNull.fulfilled, (state) => {
      state.Loader = false
      state.recentBookerID = 0
    })

      .addCase(CloseModelBooker.fulfilled, (state, action) => {
         
        state.IsClosedBooker = action.payload.data
      })
      .addCase(setRecentlyAddedBookerID.fulfilled, (state, action) => {
        state.recentBookerID = action.payload.data
      })
      .addCase(ResetCloseModelBooker.pending, (state) => {
        state.Loader = true
      })
      .addCase(ResetCloseModelBooker.fulfilled, (state, action) => {
        state.Loader = false
        state.IsClosedBooker = action.payload.data
      })
  }
})

export default appBookerSlice.reducer